export const ToastConstant = {
  DYNAMIC_FAIL: (message, time, severity) => {
    return { time: time, severity: severity, message: message };
  },
};
